import { CollectionMethod } from '@vestahealthcare/common/enums';
import {
  Address,
  BaseEnum,
  RPMVendorModel,
} from '@vestahealthcare/common/models';

import Api from './Api';

export const fetchVendorModels = async (
  vendorId: number,
): Promise<RPMVendorModel[]> => {
  const { rpmDeviceModels } = await Api.getv2(`rpm-devices/models`, {
    vendorId,
  });
  return rpmDeviceModels.items.map((x: any) => new RPMVendorModel(x));
};

export const fetchVendorShippingMethods = async (
  vendorId: number,
): Promise<BaseEnum[]> => {
  const {
    shippingMethods: { items },
  } = await Api.getv2(`rpm-devices/orders/${vendorId}/shipping-methods`);
  return items.map((x: any) => new BaseEnum(x));
};

export type OrderDeviceParams = {
  address: Address;
  deviceId: number[];
  email?: string;
  firstName: string;
  lastName: string;
  memberId: number;
  phone?: string;
  shippingMethod: string;
  taskId: number;
  vendorId: number;
};

export const orderRPMDevices = async ({
  address,
  ...params
}: OrderDeviceParams) =>
  await Api.postv2JSON(
    `rpm-devices/orders`,
    {
      address: { ...address, state: address.state?.value },
      ...params,
    },
    { showToast: true },
  );

export type UpdateRPMOrderIdParams = {
  collectionMethod: CollectionMethod;
  newDeviceNumber: string;
  oldDeviceNumber: string;
};

export const updateRPMDeviceId = async (
  orderDeviceId: string,
  vendorDeviceId: string,
) =>
  await Api.patchv2JSON(
    `rpm-devices/order-devices/${orderDeviceId}`,
    {
      vendorDeviceId,
    },
    { showToast: true },
  );
